@use "../../styles/breakpoint.module.scss" as *;

.root {
    padding: var(--spacer-24);
    border-radius: var(--border-radius-md);
    container-type: inline-size;
}

.content {
    display: flex;
    gap: var(--spacer-16);
    align-items: center;

    @container (max-width: 499px) {
        align-items: flex-start;
    }
}

.header {
    display: flex;
    gap: var(--spacer-24);
    align-items: flex-end;
    flex-grow: 1;

    @container (max-width: 499px) {
        flex-direction: column;
        align-items: flex-start;
    }
}

.author {
    align-self: stretch;
    display: flex;
    flex-direction: column;
    gap: var(--spacer-8);
    justify-content: center;
    flex: 1 0 auto;
}

.picture {
    flex-shrink: 0;
}

.avatar {
    width: var(--spacer-80);
    height: var(--spacer-80);
    border-radius: 999px;

    @media ($below-mobile) {
        width: var(--spacer-120);
        height: var(--spacer-120);
    }
}

.eyebrow {
    composes: fontEyebrow14 from "../../styles/composable/typography.module.css";
}

.name {
    font: var(--font-h-24);
}

.description {
    margin-top: var(--spacer-16);
}

.socialLinks {
    composes: listReset from "../../styles/composable/utility.module.css";
    display: flex;
    gap: var(--spacer-16);
    align-items: center;
    justify-content: flex-end;
    flex-wrap: wrap;
    padding-bottom: 3px;

    @container (max-width: 499px) {
        padding-bottom: 0;
    }

    li {
        font-size: 0;
    }
}

.socialLink {
    font: var(--font-s-14);
    text-decoration: underline;
}

.socialIcon {
    font-size: 0;

    svg {
        width: 20px;
        height: 20px;
    }
}

.socialIconOverrideColor {
    composes: socialIcon;

    svg {
        fill: currentColor;

        path {
            fill: currentColor;
        }
    }
}
